// ---------------------------------------------------------------------------
// Form values -> create-run request. Kept apart from the page so it can be
// tested without pulling in the API client and its required env vars.
// ---------------------------------------------------------------------------

import type { KgGenerationFormValues } from '../../components/SyntheticGen/index.js';
import type { SyntheticRunConfig } from '../../services/syntheticJob.interface.js';

export function toCreateRequest(
  values: KgGenerationFormValues,
): SyntheticRunConfig {
  return {
    domain: values.contextMode === 'domain' ? values.domain : undefined,
    scenario: values.contextMode === 'scenario' ? values.scenario : undefined,
    totalMessages: values.totalMessages,
    minUsers: values.minUsers,
    maxUsers: values.maxUsers,
    numTopics: values.numTopics,
    numPhases: values.numPhases,
    noiseRatio: values.noiseRatio,
    tones: values.tones.length > 0 ? values.tones : undefined,
    styles: values.styles.length > 0 ? values.styles : undefined,
    expertiseBias: values.expertiseBias,
    useBatchedEpisodes: values.useBatchedEpisodes || undefined,
    useAgent: values.useAgent || undefined,
    agentShare: values.useAgent ? values.agentShare : undefined,
  };
}
